var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title flex"},[_c('i',{staticClass:"line"}),_c('div',{staticClass:"title-text font-s-20 font-w-b"},[_vm._v(_vm._s(_vm.Titles)+" "),_c('span',{staticClass:"TitleText"},[_vm._v(_vm._s(_vm.type))])])])}
var staticRenderFns = []

export { render, staticRenderFns }